import { Base, Component, Prop, Provide } from '@/vue-property-decorator'
import { GameCardCommonProps } from '../../../common.type'
import { getProps } from './getProps'

// 彩金池专用small
export type SquareBelowCardMysize = 'default' | 'larger'
/** 游戏卡片-标准版
 * 上方正方型图片,下方结合文字
 */
export type SquareProps = Omit<GameCardCommonProps, 'bgImg'>
/** 插槽 */
type Slots = {
  /** 状态名称标签 */
  labelGameStatus: void
}
/** 游戏卡片
 * 上方正方型图片,下方结合文字
 */
@Component<BasePropsConfig>({
  name: 'BasePropsConfig'
})
export default class BasePropsConfig extends Base<
  unknown,
  SquareProps,
  unknown,
  Slots
> {
  /** 获得props */
  public static getProps = getProps

  @Prop()
  protected status!: SquareProps['status']
  @Prop()
  protected isFavorited!: SquareProps['isFavorited']
  @Prop()
  protected gameName!: SquareProps['gameName']
  @Prop()
  protected imgUrl!: SquareProps['imgUrl']
  @Prop()
  protected logoUrl!: SquareProps['logoUrl']
  @Prop()
  protected isMaintain!: SquareProps['isMaintain']
  @Prop({ default: false })
  protected isCompleteImage!: SquareProps['isCompleteImage']
  @Prop({ default: true })
  protected isShowFavorited!: SquareProps['isShowFavorited']
  @Prop({ default: false })
  protected isAtSwiper!: SquareProps['isAtSwiper']
  @Prop()
  protected atSwiperDomId!: SquareProps['atSwiperDomId']
  @Prop()
  protected handleClickCard!: SquareProps['handleClickCard']
  @Prop()
  protected handleClickFavorIcon!: SquareProps['handleClickFavorIcon']
  // 将接收到的props依赖注入给子集
  @Provide('cardProps')
  protected get cardProps() {
    return this.$props as Required<SquareProps>
  }

  // 渲染入口.
  render() {
    return this.$slots.default as unknown as VueTsxSupport.JSX.Element
  }
}
